import { FC } from 'react';

import operationTypesRealNames from 'constants/operationTypesRealNames';

import { useTranslate } from 'hooks/useTranslate';
import { Society } from 'types';

import { BeneficiaryWithPlans } from './types/BeneficiarySocietyTypes';

type BeneficiarySocietyHeaderProps = {
  beneficiary: BeneficiaryWithPlans;
  society: Partial<Society>;
};

const BeneficiarySocietyHeader: FC<BeneficiarySocietyHeaderProps> = ({
  beneficiary,
  society,
}) => {
  const { t } = useTranslate();

  return (
    <div className="card-inner">
      <div className="user-card user-card-s2">
        <div className="user-avatar lg bg-primary">
          {society.additional?.logo ? (
            <img src={society.additional.logo} alt="Logo" />
          ) : (
            <span>{beneficiary?.name?.slice(0, 2)?.toUpperCase()}</span>
          )}
        </div>
        <div className="user-info">
          <h5>{beneficiary?.name}</h5>
          <span className="sub-text">{beneficiary?.jobTitle}</span>
          <div className="badge badge-outline badge-pill text-primary ucap">
            {t('Beneficiary')}
          </div>
          <span className="sub-text">
            {t('ItIsABeneficiaryOfAPlanOf', {
              planType:
                operationTypesRealNames[
                  beneficiary?.planType as keyof typeof operationTypesRealNames
                ],
              societyName: society?.name,
            })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BeneficiarySocietyHeader;
